import { TranslateService } from '@ngx-translate/core';
import { RRule, rrulestr } from 'rrule';

export class RRuleTranslator {
  constructor(private readonly _translateService: TranslateService) {}

  translateRRule(rrule: string): string {
    try {
      const rule = rrulestr(rrule);
      const options = rule.origOptions;

      let translatedRRule = '';

      // Handle frequency translation
      if (options.freq !== undefined) {
        const freqMap = {
          [RRule.YEARLY]: 'yearly',
          [RRule.MONTHLY]: 'monthly',
          [RRule.WEEKLY]: 'weekly',
          [RRule.DAILY]: 'daily',
          [RRule.HOURLY]: 'hourly',
          [RRule.MINUTELY]: 'minutely',
          [RRule.SECONDLY]: 'secondly',
        };

        const freqKey = freqMap[options.freq];
        const freq = this._translateService.instant(`RRULE.${freqKey}`);
        translatedRRule += `${this._translateService.instant('RRULE.every')} ${freq} `;
      }

      // Handle weekdays translation
      if (options.byweekday !== undefined) {
        const days = Array.isArray(options.byweekday) ? options.byweekday : [options.byweekday];
        const translatedDays = days.map((day) => this._translateService.instant(`RRULE.${day.toString().slice(0, 2).toUpperCase()}`));
        translatedRRule += `${translatedDays.join(` ${this._translateService.instant('RRULE.and')} `)} `;
      }

      // Handle month day translation
      if (options.bymonthday !== undefined) {
        translatedRRule += `${this._translateService.instant('RRULE.on the')} ${options.bymonthday} `;
      }

      // Handle until date translation
      if (options.until !== undefined) {
        const untilDate = options.until.toISOString().split('T')[0];
        translatedRRule += `${this._translateService.instant('RRULE.until')} ${untilDate} `;
      }

      // Handle start date translation
      if (options.dtstart !== undefined) {
        const startDate = options.dtstart.toISOString().split('T')[0];
        translatedRRule += `${this._translateService.instant('RRULE.starting from')} ${startDate} `;
      }

      return translatedRRule.trim();
    } catch {
      return this._translateService.instant('RRULE.RRule error: Unable to fully convert this rrule to text');
    }
  }
}
